import { render, staticRenderFns } from "./more-options-newtab.vue?vue&type=template&id=506f034c&scoped=true&"
import script from "./more-options-newtab.vue?vue&type=script&lang=js&"
export * from "./more-options-newtab.vue?vue&type=script&lang=js&"
import style0 from "./more-options-newtab.vue?vue&type=style&index=0&id=506f034c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506f034c",
  null
  
)

export default component.exports